<template>
  <div v-if="isAllowed('TICKETS', 'CREATE')">
    <SelectedBookingView :create_ticket="true" @selectedSeatsAndAccomodation="handleGetSelectedSeatsAndAccommodation"></SelectedBookingView>
  </div>
</template>

<script>
import SelectedBookingView from '../SelectedBookingView.vue';

export default {
    components: {
        SelectedBookingView
    },
  data() {
    return {
        booking: null,
        accommodation: null
    };
  },
  created: function () {
  },
  methods: {
    handleGetSelectedSeatsAndAccommodation(accomodation) {
      console.log(accomodation)
    }
  }
}
</script>
